import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Form, Input, Radio, Select } from 'antd'
import { BasicSettingWrapper, CustomSettingWrapper, FormButton, SettingWrapper } from './crossData.styled'
import CrossDataSetting from '../DashboardSetting/components/CrossData'
import { Sources } from '../../constants/Sources'
import { fetchDataSourceTree } from '../../apis/dashboard'

function CrossDataForm (props) {
  const { brandsOption, handleModalClose, loading, form, crossDataCount, setCrossDataCount, modalData } = props
  const { t: ln_t } = useTranslation()
  const formVal = Form.useWatch()
  const [anyCrossDataChange, setAnyCrossDataChange] = useState(false)
  const [dataSourceTree, setDataSourceTree] = useState([])
  const dataSourceTableMapping = dataSourceTree?.reduce((all, i) => ({ ...all, [i.dataSourceId]: i.tables?.map(t => ({ ...t, value: t.tableName, dataSourceId: i.dataSourceId })) }), {}) || []
  const uniqueDataSrcTableKeys = dataSourceTree?.map(i => i.tables?.map(j => `${i.dataSourceId}-${j.tableName}`))?.flat() || []
  const tableJoinKeyMapping = Object.values(dataSourceTableMapping)?.flat()?.reduce((all, i) => ({ ...all, [`${i.dataSourceId}-${i.tableName}`]: i.columns?.map(t => ({ ...t, value: t.columnKeyName || i.columnName, label: t.columnName, dataSourceId: i.dataSourceId })) }), {}) || []

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`dashboard.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`dashboard.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const getCrossDataKeys = fields => crossDataCount.map(sequence => fields?.map(field => ([`${sequence}-parent-${field}`, `${sequence}-child-${field}`]))).flat(Infinity)
  const validateCrossData = async (fields = ['dataSource', 'tableName', 'joinKey']) => await form.validateFields(getCrossDataKeys(fields))

  const getDataSourceTree = async () => {
    const res = await fetchDataSourceTree(formVal?.brandId)
    if (res?.status === 200) {
      setDataSourceTree(res?.data?.filter(i => i.dataSourceId)?.map(i => ({
        ...i,
        tables: i.tables?.map(table => ({ ...table, columns: table?.columns?.map(col => ({ ...col, columnKeyName: col?.columnName, columnName: col?.alias })) }))
      })))
    }
  }

  useEffect(() => {
    if (!formVal?.brandId) return
    getDataSourceTree()
    const keep = { brandId: formVal?.brandId, name: formVal?.name, source: formVal?.source }
    if (modalData?.addMode && dataSourceTree?.length) {
      form.resetFields()
      form.setFieldsValue(keep)
    }
  }, [formVal?.brandId])

  if (anyCrossDataChange) console.log()
  const crossDataProps = {
    defConfig,
    defPlaceholder,
    form,
    dataSourceTree,
    validateCrossData,
    count: crossDataCount,
    setCount: setCrossDataCount,
    dataSourceTableMapping,
    uniqueDataSrcTableKeys,
    tableJoinKeyMapping,
    setAnyCrossDataChange,
    disabled: !formVal?.brandId ? crossDataCount : modalData?.addMode ? [] : modalData?.joinCount,
    disabledActions: !formVal?.brandId,
    viewOnly: modalData?.viewOnly,
    useJoinLogic: true
  }

  return <SettingWrapper>
    <BasicSettingWrapper style={{ padding: '8px 16px 8px 0px' }}>
      <Form.Item {...defConfig('brand', 'select')} name="brandId">
        <Select
          showSearch
          placeholder={defPlaceholder('brand', 'select')}
          options={brandsOption}
          optionFilterProp="children"
          disabled={!modalData?.addMode}
        />
      </Form.Item>
      <Form.Item {...defConfig('name', 'input')}>
        <Input placeholder={defPlaceholder('name', 'input')} />
      </Form.Item>
      <Form.Item {...defConfig('source', 'select')} initialValue={Sources.FIRST_PARTY}>
        <Radio.Group
          buttonStyle="solid"
          optionType="button"
          disabled
          options={[{ value: Sources.FIRST_PARTY, label: ln_t('dashboard.firstParty') }]}
        />
      </Form.Item>
    </BasicSettingWrapper>

    <CustomSettingWrapper style={{ padding: '8px 0px 8px 16px' }}>
      <CrossDataSetting {...crossDataProps} />
      {!modalData?.viewOnly && <FormButton>
        <Button type="default" onClick={() => handleModalClose()}>{ln_t('util.cancel')}</Button>
        <Button type="primary" htmlType="submit" loading={loading}>{ln_t('util.confirm')}</Button>
      </FormButton>}
    </CustomSettingWrapper>
  </SettingWrapper>
}

export default CrossDataForm
